/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".blueText[_ngcontent-%COMP%]{color:#005cab;cursor:pointer}.blueTextNoClick[_ngcontent-%COMP%]{color:#005cab}span[_ngcontent-%COMP%]{margin-right:5px}"];
export { styles as styles };
